export default import.meta.ROLLDOWN_FILE_URL_YkANTiu98W3_QItMM2GuGA